import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import '../../resources/css/Common.css';


function GitFlowHotfixManagement() {
    const email = localStorage.getItem("email");

    return (
        <div className="page-container">
            <Header userEmail={email} />
            <div className="content-container">
                <h1>GitFlow Hotfix Management</h1>
                <p>Details about GitFlow hotfix management go here.</p>
            </div>
            <Footer />
        </div>
    );
}

export default GitFlowHotfixManagement;
